module.exports = {

    API_SEARCH_ROOMS: "/frontend/rooms/search",
    API_WEEK_SEARCH_ROOMS: "/frontend/rooms/week/search",
    API_GET_ROOM:"/frontend/rooms/room-details/",
    API_GET_ALL_ROOM:"/frontend/rooms/room-list",
    API_GET_FOTO_HOME:"/frontend/home/get-photo",
    API_GET_INSTA_FOTO:"/frontend/utils/get-photo-instagram",
    API_SEND_CONTACT_EMAIL:"/frontend/utils/send-email",
    API_SEND_CONTACT_EMAIL_PREN:"/frontend/utils/send-email-prenotazione",

    API_GET_COMBO:"/frontend/rooms/trip-composition",
    API_GET_SELL:"/frontend/rooms/get-sell",
    API_GET_PROMOTION:"/frontend/rooms/get-promotion",
    API_GET_SINGLE_SELL:"/frontend/rooms/get-sell-details/"


}